import { AbstractControl, ValidationErrors } from '@angular/forms';

const portMin = 0;
const portMax = 65535;
const positiveIntegerRegex = new RegExp(/^[0-9]+$/);

export function portValidator(control: AbstractControl): ValidationErrors | null {
    let integerValue: number;

    if (typeof control.value === 'string') {
        if (positiveIntegerRegex.test(control.value)) {
            integerValue = parseInt(control.value);
        } else {
            return invalidPort();
        }
    } else if (typeof control.value === 'number') {
        if (Number.isInteger(control.value)) {
            integerValue = control.value;
        } else {
            return invalidPort();
        }
    } else {
        return invalidPort();
    }

    if (integerValue < portMin || portMax < integerValue) {
        return invalidPort();
    }

    return null;
}

function invalidPort(): object {
    return { invalidPort: true };
}
